module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_5012.60ed7032.png";